type Props = { value: "ru" | "uz"; onToggle: () => void };

export default function LanguageSwitcher({ value, onToggle }: Props) {
  return (
    <button
      onClick={onToggle}
      className="text-xs md:text-sm px-3 py-1 rounded-full glass hover:bg-white/10 transition"
      aria-label="switch language"
      title="switch language"
    >
      {value === "ru" ? "UZ" : "RU"}
    </button>
  );
}
